import React from "react";

export const LandingStyles: React.FC = () => {
  return (
    <style>{`
      /* Garantir que o background fique fixo durante o scroll */
      .fixed {
        position: fixed;
        transform: translateZ(0);
        -webkit-transform: translateZ(0);
      }

      @keyframes fade-in {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes fade-in-up {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes gradient {
        0%,
        100% {
          background-position: 0% 50%;
        }
        50% {
          background-position: 100% 50%;
        }
      }

      @keyframes bounce-subtle {
        0%,
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-5px);
        }
      }

      .animate-fade-in {
        animation: fade-in 1s ease-out;
      }

      .animate-fade-in-up {
        animation: fade-in-up 1s ease-out;
      }

      .animate-gradient {
        background-size: 200% 200%;
        animation: gradient 3s ease infinite;
      }

      .animate-bounce-subtle {
        animation: bounce-subtle 3s ease-in-out infinite;
      }

      @keyframes float-slow {
        0%, 100% {
          transform: translate3d(0, 0, 0) rotate(0deg);
        }
        33% {
          transform: translate3d(30px, -40px, 0) rotate(5deg);
        }
        66% {
          transform: translate3d(-20px, -20px, 0) rotate(-5deg);
        }
      }

      @keyframes float-medium {
        0%, 100% {
          transform: translate3d(0, 0, 0) rotate(0deg);
        }
        33% {
          transform: translate3d(-40px, 30px, 0) rotate(-8deg);
        }
        66% {
          transform: translate3d(-10px, -35px, 0) rotate(8deg);
        }
      }

      @keyframes float-fast {
        0%, 100% {
          transform: translate3d(0, 0, 0) rotate(0deg);
        }
        25% {
          transform: translate3d(35px, 35px, 0) rotate(10deg);
        }
        50% {
          transform: translate3d(-25px, 45px, 0) rotate(-10deg);
        }
        75% {
          transform: translate3d(40px, -30px, 0) rotate(5deg);
        }
      }

      @keyframes float-reverse {
        0%, 100% {
          transform: translate3d(0, 0, 0) rotate(0deg);
        }
        33% {
          transform: translate3d(-30px, -35px, 0) rotate(-7deg);
        }
        66% {
          transform: translate3d(25px, -15px, 0) rotate(7deg);
        }
      }

      @keyframes float-diagonal {
        0%, 100% {
          transform: translate3d(0, 0, 0) scale(1);
        }
        50% {
          transform: translate3d(50px, -50px, 0) scale(1.1);
        }
      }

      @keyframes float-circular {
        0% {
          transform: translate3d(0, 0, 0);
        }
        25% {
          transform: translate3d(40px, 0, 0);
        }
        50% {
          transform: translate3d(40px, 40px, 0);
        }
        75% {
          transform: translate3d(0, 40px, 0);
        }
        100% {
          transform: translate3d(0, 0, 0);
        }
      }

      @keyframes pulse-slow {
        0%, 100% {
          opacity: 0.8;
          transform: scale(1);
        }
        50% {
          opacity: 1;
          transform: scale(1.05);
        }
      }

      @keyframes pulse-medium {
        0%, 100% {
          opacity: 0.75;
          transform: scale(1);
        }
        50% {
          opacity: 0.95;
          transform: scale(1.08);
        }
      }

      @keyframes pulse-fast {
        0%, 100% {
          opacity: 0.7;
          transform: scale(1);
        }
        50% {
          opacity: 0.9;
          transform: scale(1.1);
        }
      }

      @keyframes gradient-shift {
        0%, 100% {
          transform: rotate(0deg) scale(1);
        }
        50% {
          transform: rotate(180deg) scale(1.1);
        }
      }

      @keyframes particle {
        0% {
          transform: translate3d(0, 0, 0) scale(0);
          opacity: 0;
        }
        10% {
          opacity: 1;
          transform: translate3d(0, -20px, 0) scale(1);
        }
        90% {
          opacity: 1;
        }
        100% {
          transform: translate3d(0, -300px, 0) scale(0.5);
          opacity: 0;
        }
      }

      @keyframes float-dot {
        0%, 100% {
          transform: translate3d(0, 0, 0);
          opacity: 0.3;
        }
        25% {
          transform: translate3d(30px, -30px, 0);
          opacity: 0.6;
        }
        50% {
          transform: translate3d(50px, 0, 0);
          opacity: 1;
        }
        75% {
          transform: translate3d(30px, 30px, 0);
          opacity: 0.6;
        }
      }

      .animate-float-slow {
        animation: float-slow 28s ease-in-out infinite;
      }

      .animate-float-medium {
        animation: float-medium 24s ease-in-out infinite;
      }

      .animate-float-fast {
        animation: float-fast 18s ease-in-out infinite;
      }

      .animate-float-reverse {
        animation: float-reverse 32s ease-in-out infinite;
      }

      .animate-float-diagonal {
        animation: float-diagonal 26s ease-in-out infinite;
      }

      .animate-float-circular {
        animation: float-circular 30s ease-in-out infinite;
      }

      .animate-pulse-slow {
        animation: pulse-slow 8s ease-in-out infinite;
      }

      .animate-pulse-medium {
        animation: pulse-medium 6s ease-in-out infinite;
      }

      .animate-pulse-fast {
        animation: pulse-fast 4s ease-in-out infinite;
      }

      .animate-gradient-shift {
        animation: gradient-shift 60s linear infinite;
      }

      .animate-particle {
        animation-name: particle;
        animation-timing-function: ease-out;
        animation-iteration-count: infinite;
      }

      .animate-float-dot {
        animation-name: float-dot;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }
    `}</style>
  );
};
